import { gql } from '@apollo/client';

const GET_USER = gql`
  query getUser($cognitoId: String!) {
    getUser(cognitoId: $cognitoId) {
      username
      name
      bciUsername
      bciDealer
      bciPassword
      zurichPassword
      email
      concessionaireId
      firstName
      dealer
      role
    }
  }
`;

const INVITE_USER = gql`
  mutation inviteUser($inviteUserInput: InviteUserInput!) {
    inviteUser(inviteUserInput: $inviteUserInput)
  }
`;

const CREATE_USER = gql`
  mutation createUser($createUserInput: CreateUserInput!) {
    createUser(createUserInput: $createUserInput)
  }
`;

const GET_ALL_GUEST_USERS = gql`
  query GetAllGuestUsers($concessionaireName: String!) {
    listGuestUser(concessionaireName: $concessionaireName) {
      email
      ExpirationDate
      concessionaireName
      signupToken
    }
  }
`;

const GET_ALL_USERS = gql`
  query GetAllUsers {
    listUser {
      name
      email
      username
      bciUsername
      bciDealer
      bciPassword
      zurichPassword
      dealer
      role
    }
  }
`;

const DELETE_SIGN_UP_EMAIL = gql`
  mutation DeleteSignUpInvitation($deleteSignUpInput: String!) {
    deleteSignUpInvitation(deleteSignUpInput: $deleteSignUpInput)
  }
`;

const CONCESSIONAIRE_ADMIN_UPDATE_USER = gql`
  mutation adminUpdateUser($updateUserInput: AdminUpdateUserInput!) {
    adminUpdateUser(updateUserInput: $updateUserInput)
  }
`;

const userOperations = {
  CONCESSIONAIRE_ADMIN_UPDATE_USER,
  DELETE_SIGN_UP_EMAIL,
  GET_ALL_USERS,
  GET_ALL_GUEST_USERS,
  INVITE_USER,
  GET_USER,
  CREATE_USER,
};

export default userOperations;
